import { render } from "./Suspencer.vue?vue&type=template&id=5f772236"
import script from "./Suspencer.vue?vue&type=script&lang=js"
export * from "./Suspencer.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src17432379/src/orprio-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__